import React, { ReactNode } from 'react'
import { MemberPrice } from '@moonpig/web-core-types-graphql'
import { Box, Flex, Text } from '@moonpig/launchpad-components'
import { LogoPlusPillInverted } from '@moonpig/launchpad-assets'

export const MemberPriceDisplay = ({
  member,
  original,
  suffix,
  plusDelivery,
}: MemberPrice & { plusDelivery?: ReactNode }) => {
  return (
    <Box>
      <Text typography="typeBodyLabel">
        {original.display}
        {plusDelivery}
      </Text>
      <Flex alignItems={'center'} color="colorFeedbackSuccess" flexShrink={0}>
        <Text typography="typeBodyLabel">{member.display}&nbsp;</Text>{' '}
        {suffix && (
          <Text typography="typeBodyLabel" fontWeight={300}>
            {suffix}&nbsp;
          </Text>
        )}
        <LogoPlusPillInverted width={50} min-width={50} />
      </Flex>
    </Box>
  )
}
